import { usePricingSettingsColumns } from './usePricingSettingsColumns';
import { Alert, Table } from 'antd';
import { PricingSettingsMatrixRowDto } from '@/core';
import { usePricingSettingsMatrixState } from './usePricingSettingsMatrixState';
import { useExcelExport } from '@/components/Table/useExcelExport';
import { useTranslation } from 'react-i18next';
import styles from './PricingSettings.module.scss';

export interface Props {
  communityId: string;
  menuId: string | undefined;
  className?: string;
}

export function PricingSettingsListPanel(props: Props) {
  const { className, communityId, menuId } = props;
  const matrixState = usePricingSettingsMatrixState(communityId, menuId);
  const columns = usePricingSettingsColumns(matrixState);
  const { value, settingsExists } = matrixState;
  const { exportAction } = useExcelExport(columns, value);
  const { t } = useTranslation();

  return (
    <div className={className}>
      {!settingsExists && (
        <Alert
          className="mb-3"
          message={t('pricing.settings.notExists')}
          type="info"
          showIcon
          closable
        />
      )}

      {exportAction}
      <Table<PricingSettingsMatrixRowDto>
        columns={columns}
        dataSource={value}
        rowKey={(row) => row.categories.map((x) => x.id).join()}
        pagination={false}
        scroll={{ x: 'auto' }}
        sticky={{ offsetHeader: 56 }}
        className={styles.table}
      />
    </div>
  );
}
